import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const microsoftTeamsLogoVariants = cva('', {
  variants: {
    variant: {
      default: '',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export interface MicrosoftTeamsLogoProps
  extends React.SVGAttributes<SVGSVGElement>, VariantProps<typeof microsoftTeamsLogoVariants> {
  size?: number;
}

export const MicrosoftTeamsLogo = ({
  size = 76,
  variant = 'default',
  className,
  ...props
}: MicrosoftTeamsLogoProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 76 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(microsoftTeamsLogoVariants({ variant, className }))}
      {...props}
    >
      <path
        d="M30.8954 18.6971C31.7178 18.6514 36.9643 18.6173 37.5065 18.764C41.2342 19.0468 40.4997 23.1764 40.5347 25.7738C39.9763 25.6788 39.4545 25.6075 38.8873 25.501L38.8883 29.2912C39.4743 29.2391 39.9963 29.2426 40.585 29.2426L48.1065 29.2521C49.2377 29.2518 50.7515 29.2057 51.8582 29.2629C53.6561 29.1978 55.5928 29.2373 57.4033 29.2437L67.6729 29.2483C69.2665 29.2468 71.0809 29.1403 72.638 29.3321C75.5465 29.6904 75.4084 32.7973 75.4017 34.8781L75.3951 38.7318C75.3891 42.5277 75.4025 46.3539 75.3958 50.1271C75.3899 53.2963 73.884 56.8945 71.5539 59.0461C69.187 61.232 66.0903 62.4296 62.8543 62.282C61.2357 62.2082 59.3744 62.095 58.0067 61.1477C56.8328 63.4515 56.0332 64.971 54.195 66.8078C49.5181 71.481 43.1302 73.8123 36.6122 72.2792C31.5662 71.0923 25.8186 67.2756 23.7222 62.4189C23.0351 61.1749 22.7159 60.1026 22.2142 58.7874C22.0273 58.1402 21.947 57.7999 21.9738 57.1381L9.51153 57.1308C7.52536 57.1314 5.53025 57.1983 3.54829 57.087C2.29723 57.0167 0.724672 55.955 0.633986 54.6307C0.531682 53.1368 0.585633 51.552 0.586646 50.0467L0.586959 40.9266L0.585222 28.2126C0.582429 26.0067 0.571951 23.8086 0.609019 21.602C0.627569 20.4977 1.67342 19.1061 2.73506 18.9221C4.83296 18.5586 7.27995 18.7065 9.4356 18.707L24.3417 18.7078L28.4923 18.714C29.1184 18.7178 30.285 18.7617 30.8431 18.703L30.8954 18.6971Z"
        fill="#4C53BB"
      />
      <path
        d="M51.8582 29.2629C53.6561 29.1978 55.5929 29.2373 57.4033 29.2437L67.6729 29.2483C69.2665 29.2468 71.0809 29.1403 72.638 29.3321C75.5465 29.6904 75.4084 32.7973 75.4018 34.8781L75.3951 38.7318C75.3891 42.5277 75.4025 46.3539 75.3958 50.1271C75.3899 53.2963 73.8841 56.8945 71.554 59.0461C69.187 61.2319 66.0904 62.4295 62.8543 62.282C61.2357 62.2082 59.3745 62.095 58.0067 61.1477C56.8328 63.4515 56.0333 64.971 54.195 66.8078C49.5181 71.481 43.1302 73.8123 36.6122 72.2792C31.5662 71.0923 25.8186 67.2756 23.7222 62.4189C23.0352 61.1749 22.716 60.1026 22.2142 58.7874C23.0264 58.7139 24.982 58.7706 25.8734 58.7718L33.2408 58.7814C34.223 58.7823 36.0813 58.8325 36.9993 58.6888C39.1073 58.9243 39.2952 58.1577 40.407 56.7359C40.9183 54.1291 40.2455 48.9668 40.5224 46.5692C40.749 44.6071 40.2102 29.9916 40.585 29.2426L48.1065 29.2521C49.2377 29.2518 50.7516 29.2057 51.8582 29.2629Z"
        fill="#7B82EB"
      />
      <path
        d="M57.4033 29.2437L67.673 29.2483C69.2666 29.2468 71.0809 29.1403 72.6381 29.3321C75.5465 29.6904 75.4085 32.7973 75.4018 34.8781L75.3951 38.7318C75.3892 42.5277 75.4026 46.3539 75.3959 50.1271C75.3899 53.2963 73.8841 56.8945 71.554 59.0461C69.187 61.2319 66.0904 62.4295 62.8543 62.282C61.2358 62.2082 59.3745 62.095 58.0067 61.1477C58.772 59.0152 59.3264 57.6072 59.499 55.3044C59.6562 53.2081 59.6196 51.2541 59.6196 49.1528L59.6219 40.9857L59.6211 35.5033C59.6205 34.2183 59.6503 32.9307 59.4884 31.6538C59.3959 30.924 58.1303 29.2993 57.4033 29.2437Z"
        fill="#525ACB"
      />
      <path
        d="M36.9993 58.6888C39.1073 58.9243 39.2952 58.1577 40.407 56.7359C40.6032 57.6897 40.5274 59.2908 40.3823 60.2452L40.3457 60.2845C40.084 60.571 39.9089 60.9187 39.6927 61.2331C38.6736 62.7154 35.0799 62.3217 33.5382 62.3191L27.3766 62.3072C26.6191 62.3069 24.3125 62.2664 23.7222 62.4189C23.0352 61.1749 22.716 60.1026 22.2142 58.7874C23.0264 58.7139 24.982 58.7706 25.8734 58.7718L33.2408 58.7814C34.223 58.7823 36.0813 58.8325 36.9993 58.6888Z"
        fill="#5E62B2"
      />
      <path
        d="M40.585 29.2426L48.1065 29.2521C49.2377 29.2518 50.7516 29.2057 51.8582 29.2629C51.6304 29.4104 43.2424 29.3374 42.2794 29.3438C42.4063 35.732 42.3033 42.4694 42.3056 48.8782L42.3068 54.8717C42.3069 55.8551 42.3469 57.1052 42.2384 58.0768C42.1571 58.8054 41.1169 60.0163 40.3823 60.2452C40.5274 59.2908 40.6032 57.6897 40.407 56.7359C40.9183 54.1291 40.2455 48.9668 40.5224 46.5692C40.749 44.6071 40.2102 29.9917 40.585 29.2426Z"
        fill="#525ACB"
      />
      <path
        d="M38.8884 29.2912C39.4744 29.2391 39.9963 29.2426 40.585 29.2426C40.2102 29.9916 40.749 44.6071 40.5224 46.5692C40.2456 48.9668 40.9184 54.1291 40.407 56.7359C39.2953 58.1577 39.1074 58.9243 36.9994 58.6888C38.1235 57.6642 39.288 56.2686 38.7658 54.6096C38.9343 53.5224 38.8902 52.263 38.8843 51.1511L38.8653 46.929C38.848 41.2242 38.7029 34.9436 38.8884 29.2912Z"
        fill="#474986"
      />
      <path
        d="M38.7658 54.6096C39.288 56.2686 38.1235 57.6642 36.9994 58.6888C36.0814 58.8325 34.2231 58.7823 33.2408 58.7814L25.8735 58.7718C24.9821 58.7706 23.0265 58.7139 22.2143 58.7874C22.0274 58.1402 21.9471 57.7999 21.9739 57.1381C26.5337 56.9529 31.1918 57.2832 35.7564 57.0572C37.271 56.9822 38.3472 56.0321 38.7658 54.6096Z"
        fill="#393B6D"
      />
      <path
        d="M37.5065 18.764C41.2342 19.0468 40.4997 23.1764 40.5347 25.7738C39.9763 25.6788 39.4545 25.6075 38.8873 25.501C38.6615 22.4984 39.6537 20.3937 36.3901 18.778L37.5065 18.764Z"
        fill="#474986"
      />
      <path
        d="M11.2766 27.5288L28.1182 27.5316L28.1114 30.9239C26.0606 30.8759 23.812 30.9244 21.7451 30.9261L21.7482 41.8965L21.7388 48.32L17.6632 48.3221L17.6641 30.9243L11.2761 30.9201L11.2766 27.5288Z"
        fill="#FEFEFE"
      />
      <path
        d="M30.8955 18.6971C30.6167 18.1865 30.5712 17.6803 30.4367 17.1276C29.2362 12.196 31.3896 6.98859 35.8872 4.53387C38.5741 3.08265 41.7221 2.7402 44.6582 3.57977C54.4231 6.4727 55.6463 19.8255 46.6918 24.4741C44.7074 25.5042 42.7396 25.8001 40.5347 25.7738C40.4998 23.1764 41.2342 19.0468 37.5066 18.764C36.9644 18.6173 31.7178 18.6514 30.8955 18.6971Z"
        fill="#7B82EB"
      />
      <path
        d="M65.3773 10.0716C69.7021 9.86516 73.3782 13.1979 73.5956 17.5222C73.8129 21.8465 70.4895 25.531 66.1657 25.7593C61.8265 25.9884 58.1259 22.6505 57.9078 18.3107C57.6897 13.9709 61.0369 10.2787 65.3773 10.0716Z"
        fill="#525ACB"
      />
    </svg>
  );
};
